import * as React from 'react';
import Divider from '@mui/material/Divider';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import StoreIcon from '@mui/icons-material/Store';
import KitchenIcon from '@mui/icons-material/Kitchen';
import PrintIcon from '@mui/icons-material/Print';
import SmsIcon from '@mui/icons-material/Sms';
import KeyIcon from '@mui/icons-material/Key';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { logoutUser } from '../utilities/user-util';
import store, { useAppSelector } from '../store';
import { DateTime } from 'luxon';

const categories = [
  {
    id: 'Configurations',
    children: [
      { id: 'Stores', icon: <StoreIcon />, path: '/layout/stores' },
      { id: 'Cabinets', icon: <KitchenIcon />, path: '/layout/cabinets' },
      // { id: 'Printers', icon: <PrintIcon />, path: '/layout/printers' },
      // { id: 'SMS Templates', icon: <SmsIcon />, path: '/layout/smstemplates' },
      { id: 'Branding', icon: <AutoAwesomeIcon/>, path: '/layout/branding' },
      { id: 'Keys', icon: <KeyIcon/>, path: '/layout/keys' }
    ],
  },
];

const item = {
  py: '2px',
  px: 3,
  color: 'rgba(255, 255, 255, 0.7)',
  '&:hover, &:focus': {
    bgcolor: 'rgba(255, 255, 255, 0.08)',
  },
};

const itemCategory = {
  boxShadow: '0 -1px 0 rgb(255,255,255,0.1) inset',
  py: 1.5,
  px: 3,
};

export default function Navigator(props: DrawerProps) {
  const { ...other } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const { logoutAt } = useAppSelector(store => store.authorization);

  const remainingDays = () => {
    return logoutAt ? Math.ceil(DateTime.utc().diff(DateTime.fromSeconds(logoutAt), ['days']).days * -1) : 0;
  };

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <ListItem sx={{ ...item, ...itemCategory, fontSize: 22, color: '#fff' }}>
          PUC Management Tool
        </ListItem>
        {categories.map(({ id, children }) => (
          <Box key={id} sx={{ bgcolor: '#101F33' }}>
            <ListItem sx={{ py: 2, px: 3 }}>
              <ListItemText sx={{ color: '#fff' }}>{id}</ListItemText>
            </ListItem>
            {children.map(({ id: childId, icon, path }) => (
              <ListItem disablePadding key={childId}>
                <ListItemButton selected={path === location.pathname} sx={item} onClick={() => navigate(path)}>
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText>{childId}</ListItemText>
                </ListItemButton>
              </ListItem>
            ))}
            <Divider sx={{ mt: 2 }} />
          </Box>
        ))}
      </List>
      <Button
        onClick={() => logoutUser(store)}
        sx={{
          marginTop: 'auto',
          color: 'rgba(255, 255, 255, 0.7)'
        }}>
        Logout
      </Button>
      <Typography 
        variant='caption' 
        sx={{
          marginBottom: '20px'
        }}
        color='rgba(255, 255, 255, 0.7)'>
        {`Expires in ${remainingDays()} ${remainingDays() < 2 ? 'day' : 'days'}`}
      </Typography>
    </Drawer>
  );
}
